import { useCallback } from 'react';
import { useAngularContext } from 'AngularContext';
import { type AnyObject } from '@Types';
import { type StreamForStreamDashboard } from 'Lessons';
import { useSiteMetadata } from 'SearchEngineOptimization/useSiteMetadata';
import { type ShareProvider } from '../StreamDashboard.types';
import { getStreamLogInfo, isBlueOceanStream } from '../selectors';
import { toStreamForShareInfo } from '../toStreamForDashboard';

/*
    A blue ocean student who shares the Blue Ocean course gets the blue ocean copy. contentCompletedShareInfo
    delegates to contentDefaultShareInfo today. Keep the call so a future difference has a place to go.
*/
export function useShareCompletedStream(stream: StreamForStreamDashboard, isBlueOceanUser: boolean) {
    const $injector = useAngularContext();
    const SiteMetadata = useSiteMetadata();

    return useCallback(
        (provider: ShareProvider) => {
            const $rootScope = $injector.get<AnyObject>('$rootScope');
            const ShareService = $injector.get<AnyObject<(...args: unknown[]) => void>>('Navigation.ShareService');

            const shareInfo =
                isBlueOceanUser && isBlueOceanStream(stream)
                    ? SiteMetadata.blueOceanShareInfo($rootScope.currentUser)
                    : SiteMetadata.contentCompletedShareInfo($rootScope.currentUser, toStreamForShareInfo(stream));

            ShareService.share('stream', provider, shareInfo, getStreamLogInfo(stream));
        },
        [stream, isBlueOceanUser, $injector, SiteMetadata],
    );
}
